module.exports = __webpack_public_path__ + "img/hazmat-suit.327a81fe.svg";